class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    let forceOpen = false;
    Array.from(this.content.children).forEach((child) => {
      if (child.hasAttribute("forceOpen")) {
        forceOpen = true;
      }
    });

    setTimeout(() => {
      if (!this.contains(document.activeElement) && !forceOpen) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    this.additionalHeaderLinks = this.querySelectorAll("a[handle]");
    this.mainLinks = this.querySelector('.grid-menu__item[handle="main"]');
    this.defaultLinks = this.querySelectorAll(
      '.grid-menu__item[handle="default"]'
    );
    this.allLinks = this.querySelectorAll(".grid-menu__item");
    this.allDefaultLinks = this.querySelector(".grid-menu__item:not([handle]")

    Array.from(this.additionalHeaderLinks)?.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        Array.from(this.allLinks).forEach((link) => {
          if (link.getAttribute("handle") === e.target.getAttribute("handle")) {
            link.setAttribute("active", "");
            e.target.setAttribute('active', "")
          } else if (link.getAttribute("handle") !== "main") {
            link.removeAttribute("active");
            Array.from(this.additionalHeaderLinks).forEach(additionalLink => {
              if (additionalLink !== e.target) {
                additionalLink.removeAttribute("active")
              }
            })
          }
        });
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
